import React from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { getActiveModule } from "../../moduleConfig";
import { getBranding, getThemeColor, saveThemeColor, THEME_PRESETS } from "../../theme/branding";

const NavbarView = ({
  user,
  search,
  handleCheck,
  isSidebarVisible,
  onSearchChange,
  onModuleChange,
  onToggleSidebar,
  isAIOpen,
  onToggleAI
}) => {
  const brand = getBranding();
  const activeModule = getActiveModule();
  const [themeColor, setThemeColor] = React.useState(getThemeColor());
  const userName = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "Mon profil";


  
  return (
    <header className="ev-navbar">
      <button
        type="button"
        className="ev-sidebar-toggle"
        onClick={onToggleSidebar}
        aria-label={isSidebarVisible ? "Masquer le menu latéral" : "Afficher le menu latéral"}
        aria-expanded={isSidebarVisible}
        title={isSidebarVisible ? "Masquer le menu" : "Afficher le menu"}
      >
        <FeatherIcon icon={isSidebarVisible ? "sidebar" : "menu"} size={20} />
      </button>

      <div className="ev-navbar__title">
        <span className="ev-navbar__eyebrow">Module {brand.moduleLabel}</span>
        <span className="ev-navbar__name" title={brand.displayName}>{brand.displayName}</span>
      </div>

        <select
          className="form-select form-select-sm ev-module-select"
          name="module"
          value={activeModule}
          aria-label="Changer de module"
          onChange={(event) => onModuleChange(event.target.value, user.id)}
        >
          { ( handleCheck("Afficher ressource humaine") == true) && (<option value="rh">Ressources humaines</option>) }
          { ( handleCheck("Afficher comptabilité") == true) && (<option value="compta">Comptabilité</option>) }
          { ( handleCheck("Afficher pedagogie") == true) && (<option value="stat">Pédagogie</option>) }
          { ( handleCheck("Afficher bibliothèque") == true) && (<option value="biblio">Bibliothèque</option>) }
          <option value="portal">Portail principal</option>
        </select>

      <form action={`/search/${search}`} method="GET" className="ev-search">
        <input
          type="search"
          className="form-control form-control-sm"
          placeholder="Rechercher..."
          name="search"
          onChange={onSearchChange}
          value={search}
          aria-label="Rechercher"
        />
        <button type="submit" className="btn btn-sm" aria-label="Lancer la recherche">
          <FeatherIcon icon="search" size={18} />
        </button>
      </form>

      <button
        type="button"
        className={`ev-ai-toggle ${isAIOpen ? "is-active" : ""}`}
        title={isAIOpen ? "Fermer Evivesoma IA" : "Ouvrir Evivesoma IA"}
        aria-label={isAIOpen ? "Fermer Evivesoma IA" : "Ouvrir Evivesoma IA"}
        aria-expanded={isAIOpen}
        onClick={onToggleAI}
      >
        <FeatherIcon icon="cpu" size={17} />
        <span>IA</span>
      </button>

      <div className="ev-theme-picker" aria-label="Couleur de l’établissement">
        {THEME_PRESETS.map((theme) => (
          <button
            key={theme.id}
            type="button"
            className={`ev-color-swatch ${themeColor === theme.color ? "is-active" : ""}`}
            style={{ backgroundColor: theme.color }}
            onClick={() => { saveThemeColor(theme.color); setThemeColor(theme.color); }}
            title={`Thème ${theme.label}`}
            aria-label={`Choisir le thème ${theme.label}`}
          />
        ))}
      </div>

      <Link to="/profile" className="ev-user">
        <img
          src={ navigator.onLine ? (user?.avatar || brand.logo ) : process.env.REACT_APP_ESTABLISHMENT_LOGO }
          alt={userName} 
          className="rounded-circle"
          onError={(event) => { event.currentTarget.src = brand.logo; }}
        />
        <span className="ev-user__meta">
          <strong>{userName}</strong>
          <small>Mon profil</small>
        </span>
      </Link>
    </header>
  );
};

export default NavbarView;
